import request from '@/utils/request'
import { ouchnCustom } from "@/service"

// 查询合作机构列表
export function listCoagency(query){
  return request({
    url:ouchnCustom + '/web/cp/inst/instList',
    method:'get',
    params: query
  })
}
// 查询合作机构详情——左侧机构信息
export function CoagencyInfo(deptId){
  return request({
    url:ouchnCustom + '/web/cp/inst/instDetail?deptId='+deptId,
    method:'get',
  })
}
// 查询合作机构详情——右侧作者列表
export function RlistAuthor(query){
  return request({
    url:ouchnCustom + '/web/oc/author/listByInstId',
    method:'get',
    params: query
  })
}
// 查询合作机构详情——右侧商品列表
export function RlistBook(query){
  return request({
    url:ouchnCustom + '/web/goods/listGoodsByInstId',
    method:'get',
    params: query
  })
}